import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import CookieConsentBanner from "./components/CookieConsentBanner";
import { useDemoSetup } from "./hooks/useDemoSetup";

function DemoSetupRunner() {
  useDemoSetup();
  return null;
}

function App() {
  return (
    <AuthProvider>
      <DemoSetupRunner />
      <Routes />
      <CookieConsentBanner />
    </AuthProvider>
  );
}

export default App;
